@switch (step()) {
	@case ('upload') {
		<div class="gwc-secure-scan__phone"
			[class.gwc-secure-scan__phone--error]="formControl.touched && formControl.invalid">
			<h4>
				{{ is_photo() ? "Use your phone's camera to take a passport style photo." : "Use your mobile phone's camera to scan your documents" }}
			</h4>
			<div class="gwc-secure-scan__options">
				<section class="gwc-secure-scan__options-item">
					<h5>Send a link via text</h5>
					<mat-form-field floatLabel="always"
						class="gwc-secure-scan__phone-input">
						<mat-label>Enter Mobile Number</mat-label>
						<input matInput 
							mask="(000) 000-0000"
							[formControl]="phone">
					</mat-form-field>
					<button mat-stroked-button
						color="primary"
						[disabled]="sendingText()"
						(click)="sendText()">
						Send Text
					</button>
				</section>
				@if (qrLink()) {
					<section class="gwc-secure-scan__options-divider">or</section>
					<section class="gwc-secure-scan__options-item gwc-secure-scan__options-item--not-mobile">
						<h5>Scan the QR code</h5>
						<!-- SVG, not canvas: the canvas is rasterised at [width] CSS px and
						     upscaled on Retina, which blurs every module edge. Level M is
						     plenty for an on-screen code and keeps the symbol ~37 modules for
						     the 84-char link, so each module is ~3.7 px at 150 (vector, so
						     still crisp). 150 = halfway between the original 120 and 180. -->
						<qrcode [qrdata]="qrLink()"
							[width]="150"
							elementType="svg"
							errorCorrectionLevel="M"
							[margin]="2"
							colorDark="#000000">
						</qrcode>
					</section>
					<section class="gwc-secure-scan__options-item gwc-secure-scan__options-item--mobile">
						<h5>{{ is_photo() ? 'Click the link below to take a photo.' : 'Click the link below to scan your documents'}}</h5>
						<a mat-stroked-button
							color="primary"
							[disabled]="sendingText()"
							[href]="qrLink()"
							target="_blank">
							{{ is_photo() ? 'Take a Photo' : 'Scan Documents' }}
						</a>
					</section>
				}
			</div>

			@if (formControl.touched && formControl.invalid){
				<div class="gwc-secure-scan__error">
					Please press "Send Text" to start the process before proceeding.
				</div>
			}
		</div>
		@if (props['allow_upload']) {
			<div class="gwc-secure-scan__upload">
				Or, <a (click)="uploadFile(0)">upload files</a> from your computer
			</div>
		}
	}
	@case ('phone') {
		<h4 class="gwc-secure-scan__message">
			@if (is_photo()) {
				{{ is_text() ? 'Please use the link in the text message to take your photo' : 'Please use your phone to take your photo' }}
			} @else {
				{{ is_text() ? 'Please use the link in the text message to scan your documents' : 'Please use your phone to scan your document' }}
			}
		</h4>
		<ul class="gwc-secure-scan__documents">
			@for (document of documents(); track document.document_uuid) {
				<li>
					<div class="gwc-secure-scan__label">
						@if (listening() === document.document_uuid || !isCompleted(document.document_uuid)()) {
							<mat-spinner [class.gwc-secure-scan__hidden]="listening() !== document.document_uuid && !isCompleted(document.document_uuid)()"
								diameter="20">
							</mat-spinner>
						} @else if (isCompleted(document.document_uuid)()) {
							<img alt="checkmark"
								src="assets/scanner/checkmark.svg"/>
						}
						{{ document.friendly_name }}
					</div>
				</li>
			}
		</ul>
	}
	@case ('crop') {
		<section class="gwc-secure-scan__crop">
			@if (!imageChangedEvent()) {
				@switch(uploadingDocument().type) {
					@case ('drivers_license_front') {
						<p>
							<strong>Upload a picture of the front of your Driver's License</strong><br/><br/>
							Please ensure the entire front of the driver's license, including the edges of the card, is visible and free from any glare that could obscure the text.
						</p>
					} 
					@case ('drivers_license_back') {
						<p>
							<strong>Upload a picture of the back of your Driver's License</strong><br/>
							Please ensure the entire back of the driver's license, including the edges of the card, is visible and free from any glare that could obscure the text.
						</p>
					} 
					@case ('online_passport_photo') {
						<h3>
							<strong>Please make sure the photo meets the following requirements:</strong>
						</h3>
						<img 
							src="assets/scanner/online_passport_photo@2x.png" 
							alt="Passport Photo Requirements" 
							style="height: 200px;" />
						<ul>
							<li>Photo is taken using a white background.</li>
							<li>The applicant has a neutral facial expression or a natural smile.</li> 
							<li>The applicant doesn't wear glasses, hat, or anything that covers your head (except for religious purposes).</li>
							<li>The applicant doesn't wear any uniform.</li>
						</ul>
						<p class="gwc-secure-scan__hint">
							Upload the original photo, not a cropped one. We'll frame it, check it and replace the background for you.
						</p>
					}
					@default {
						@if (uploadingDocument().client_view) {
							<div [innerHTML]="uploadingDocument().client_view"></div>
						}
					}
				}

				<input #input 
					type="file" 
					[multiple]="false"
					class="gwc-secure-scan__input"
					accept="{{ uploadingDocument().type === 'pdf_document' ? 'application/pdf' : 'image/png, image/jpeg' }}"
					(change)="fileUploaded($event)"/>
				<gwc-button 
					color="primary"
					[disabled]="uploadingImage()"
					[spinner]="uploadingImage()"
					(click)="file_input.nativeElement.click()">
					{{ uploadingImage() && uploadingDocument().type === 'online_passport_photo' ? 'Checking your photo…' : is_photo() ? 'Upload Passport Type Photo' : 'Upload Document Scan' }}
				</gwc-button>
			} @else {
				@if (photoNotice()) {
					<div class="gwc-secure-scan__notice gwc-secure-scan__notice--warning">
						{{ photoNotice() }}
					</div>
				}
				<image-cropper class="gwc-secure-scan__cropper"
					[imageChangedEvent]="imageChangedEvent()"
					[maintainAspectRatio]="cropAspectRatio() !== null"
					[aspectRatio]="cropAspectRatio() ?? 1"
					format="jpeg"
					output="blob"
					(imageCropped)="imageCropped($event)"
					(imageLoaded)="imageLoaded($event)"
					(cropperReady)="cropperReady()"
					(loadImageFailed)="loadImageFailed()"
				></image-cropper>
				@if (isLicense(uploadingDocument())) {
					<p class="gwc-secure-scan__hint">
						Drag the box so it covers the whole card. We'll straighten it and check it for you.
					</p>
				}
				<gwc-button
					color="primary"
					[disabled]="uploadingImage()"
					[spinner]="uploadingImage()"
					(click)="uploadCroppedImage()">
					{{ is_photo() ? 'Confirm Passport Type Photo' : 'Confirm Document Scan' }}
				</gwc-button>
			}
			@if (uploadError()) {
				<div class="gwc-secure-scan__error">
					{{ uploadError() }}
				</div>
			}
		</section>
	}
	@case ('photo-review') {
		@if (photoReview(); as review) {
			<section class="gwc-secure-scan__review">
				<img class="gwc-secure-scan__review-preview"
					alt="Your photo after our checks"
					[src]="getDocumentImg(review.document_uuid)"/>
				@if (review.blocked) {
					<div class="gwc-secure-scan__notice gwc-secure-scan__notice--stop" role="alert">
						<strong>This photo can't be used.</strong>
						Please choose a different photo without the problems below.
					</div>
				} @else if (review.fails.length > 0) {
					<div class="gwc-secure-scan__notice gwc-secure-scan__notice--warning">
						<strong>Please check this photo.</strong>
						You can use it, but a photo without the problems below is more likely to be accepted.
					</div>
				} @else {
					<div class="gwc-secure-scan__notice">
						<strong>Your photo passed our checks.</strong>
						@if (review.background_removed) {
							We replaced the background for you.
						}
					</div>
				}
				@if (review.fails.length > 0) {
					<ul class="gwc-secure-scan__checks">
						@for (fail of review.fails; track fail.test_key) {
							<li class="gwc-secure-scan__check gwc-secure-scan__check--failed">
								<svg aria-hidden="true"><use href="assets/scanner/scanner_icons.svg#failed" /></svg>
								<div>
									<strong>{{ fail.description }}</strong>
									@if (fail.explanation) {
										<p>{{ fail.explanation }}</p>
									}
								</div>
							</li>
						}
					</ul>
				}
				@if (review.success.length > 0) {
					<ul class="gwc-secure-scan__checks gwc-secure-scan__checks--passed">
						@for (pass of review.success; track pass.test_key) {
							<li class="gwc-secure-scan__check">
								<svg aria-hidden="true"><use href="assets/scanner/scanner_icons.svg#pass" /></svg>
								<div>{{ pass.description }}</div>
							</li>
						}
					</ul>
				}
				<div class="gwc-secure-scan__review-actions">
					<button mat-stroked-button
						color="primary"
						(click)="chooseAnotherPhoto()">
						Choose a different photo
					</button>
					@if (!review.blocked) {
						<gwc-button color="primary"
							(click)="usePhoto()">
							Use this photo
						</gwc-button>
					}
				</div>
			</section>
		}
	}
	@case ('completed') {
		@if (!is_photo()) {
			<h4 class="gwc-secure-scan__message">
				All documents have been scanned.
			</h4>
		}

		<!-- What the licence barcode did to the application -->
		@if (prefilled().length > 0) {
			<div class="gwc-secure-scan__notice">
				<strong>We read your license.</strong>
				We filled in your {{ prefilledDescription() }} from it — please check them before you submit.
			</div>
		}
		<!-- The typed-vs-barcode mismatch table and the per-check list are
		     phone-only by design (2026-08-28): the desktop step stays quiet
		     unless there is an actual problem with the scan. -->
		@if (licenseValuesApplied().length > 0) {
			<div class="gwc-secure-scan__notice">
				<strong>Updated from your license.</strong>
				Your {{ licenseValuesDescription() }} now match your license — you can still change them before you submit.
			</div>
		}
		@if (prefill()?.consistency === 'mismatch') {
			<div class="gwc-secure-scan__notice gwc-secure-scan__notice--warning">
				<strong>The front and back don't look like the same license.</strong>
				Please retake whichever side is wrong.
			</div>
		}

		@for (document of documents(); track document.document_uuid; let i = $index) {
			<div class="gwc-secure-scan__completed">
				<div class="gwc-secure-scan__label">
					<img src="assets/scanner/checkmark.svg"/>
					{{ document.friendly_name }}
					<button mat-stroked-button
						color="primary"
						[disabled]="sendingText()"
						(click)="retakePhoto(document, i)">
						Retake
					</button>
				</div>
				@if (isLicense(document) && verificationFor(document.document_uuid); as verification) {
					@if (verification.hard_stop) {
						<div class="gwc-secure-scan__notice gwc-secure-scan__notice--stop" role="alert">
							<strong>{{ verification.error_code === 'LICENSE_EXPIRED' ? 'This license is expired' : 'This license can’t be used' }}</strong>
							{{ verification.message }}
						</div>
					} @else if (!verification.ok && verification.message) {
						<div class="gwc-secure-scan__notice gwc-secure-scan__notice--warning">
							{{ verification.message }}
						</div>
					}
				}
				@if (document.type === 'pdf_document') {
					<pdf-viewer [src]="getDocumentImg(document.document_uuid)"
						[render-text]="true"
						[original-size]="false"
						style="width: 400px; height: 500px"
					></pdf-viewer>
				} @else {
				<img class="gwc-secure-scan__completed-preview"
					[src]="getDocumentImg(document.document_uuid)"/>
				}
			</div>
		}
	}
}